var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b',[_vm._v("TOTAL : "+_vm._s(_vm.totalList))])])])}
var staticRenderFns = []

export { render, staticRenderFns }